<template>
  <div v-if="show" class="flex flex-col items-center justify-center py-12">
    <div class="animate-spin text-4xl mb-4">⏳</div>
    <p class="text-gray-600 text-lg">{{ message }}</p>
  </div>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: true
  },
  message: {
    type: String,
    default: 'Cargando...'
  }
})
</script>
